import type { ShiftHandoverDto } from '@munifocus/contracts-gov';
import { intlLocale } from '../../lib/relative-time';
import { frenchFirstOfMonth } from '@munifocus/utils';

export type HandoverStatus = 'pending' | 'acknowledged' | 'withdrawn';

export function handoverStatus(
  h: Pick<ShiftHandoverDto, 'acknowledgedAt' | 'cancelledAt'>,
): HandoverStatus {
  if (h.cancelledAt) return 'withdrawn';
  return h.acknowledgedAt ? 'acknowledged' : 'pending';
}

/** "24 Oct, 20:00 – 25 Oct, 08:00" in the reader's language, Atlantic time. */
export function formatPeriod(start: string, end: string, language: string | undefined): string {
  const fmt = new Intl.DateTimeFormat(intlLocale(language), {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'America/Moncton',
  });
  // French writes the first of the month "1er".
  const at = (iso: string) => frenchFirstOfMonth(fmt.format(new Date(iso)));
  return `${at(start)} – ${at(end)}`;
}

/** `YYYY-MM-DDTHH:mm` for a datetime-local input, in the browser's zone. */
export function toLocalInput(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}`;
}
